<h2
  mat-dialog-title
  class="display-flex align-items-center"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragDisabled]="isBlockDraggable"
>
  <ng-container *ngIf="!isLoading; else headerLoading">
    <div class="display-flex flex-column grid-gap-8">
      <div class="display-flex align-items-center">
        <app-custom-inspection-header
          (mouseout)="isBlockDraggable = false"
          (mouseover)="isBlockDraggable = true"
          [header]="inspectionTemplate.name"
          (headerChanged)="headerChange($event)"
        ></app-custom-inspection-header>
        <span class="action-buttons" (mouseout)="isBlockDraggable = false" (mouseover)="isBlockDraggable = true">
          <button mat-icon-button (click)="removeTemplate()">
            <app-icon [svg]="EIcon.BB_TRASH"></app-icon>
          </button>
        </span>
      </div>
    </div>
  </ng-container>

  <ng-template #headerLoading>
    <app-skeleton-loader class="w-100 h-100 header-loader"></app-skeleton-loader>
  </ng-template>

  <button
    mat-icon-button
    class="ml-auto"
    (click)="cancel()"
    (mouseout)="isBlockDraggable = false"
    (mouseover)="isBlockDraggable = true"
  >
    <mat-icon>clear</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div
    class="display-flex align-items-center grid-gap-8 justify-content-center mb-4"
    *ngIf="isUnitModeAvailable"
    [matTooltip]="'Edit just unit ' + data.turnover.unitName + ' or the entire template'"
    [matTooltipDisabled]="!showSwitcher"
  >
    <ng-container *ngIf="showSwitcher; else unitName">
      <span class="body-small-bold text-color gray11">Edit mode:</span>
      <app-slide-toggle
        [attrLeftLabel]="data.turnover.unitName"
        [labelCss]="'body-small text-color gray11'"
        [attrRightLabel]="'Template'"
        [ngModel]="isTemplateMode"
        (ngModelChange)="changeMode($event)"
      ></app-slide-toggle>
    </ng-container>
    <ng-template #unitName>
      <span class="body-small-bold text-color gray11">Mode:&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span class="body-small text-color gray11">{{ data.turnover.unitName }}</span>
    </ng-template>
  </div>
  <div class="custom-inspection-dnd-content" cdkDropListGroup>
    <div cdkDropList (cdkDropListEntered)="enter($event)" (cdkDropListDropped)="drop()" #placeholder></div>
    <ng-container *ngIf="!isItemsLoading; else spinnerTemplate">
      <div
        cdkDropList
        (cdkDropListEntered)="enter($event)"
        (cdkDropListDropped)="drop()"
        *ngFor="let item of activeInspectionContent?.items; trackBy: trackById"
      >
        <div cdkDragBoundary=".custom-inspection-dnd-content" cdkDrag appDragCursor>
          <app-custom-inspection-item
            [item]="item"
            (itemNameChange)="itemNameChange($event)"
            (enterPressed)="enterPressed($event)"
            (itemChecked)="itemCheckedChange($event)"
            (remove)="remove($event)"
          ></app-custom-inspection-item>
        </div>
      </div>

      <div #addButtonContainer>
        <button mat-button (click)="add()" class="">
          <span class="display-flex align-items-center justify-content-center add-button">
            <mat-icon [inline]="true" class="add-button__icon">add</mat-icon>
            <span class="add-button__text">add item</span>
          </span>
        </button>
      </div>
    </ng-container>
  </div>

  <ng-template #spinnerTemplate>
    <div class="spinner-container">
      <app-skeleton-loader class="w-100 h-100"></app-skeleton-loader>
    </div>
  </ng-template>
</mat-dialog-content>
